// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags-module--tags--1L_ct","tags__list":"Tags-module--tags__list--91FqN","tags__listItem":"Tags-module--tags__listItem--2PFdA"};